import React from 'react';
import { WebUrlData } from '@base-configs';
import { Navigate } from 'react-router-dom';

export function DataFeature() {
  return <Navigate to={WebUrlData.data_headquarter} replace />;
}
